import React, { Component } from 'react';
import './StatusSummary.scss';
import Stepper from './Stepper';

export class StatusSummary extends Component {
    static displayName = StatusSummary.name;

    constructor(props) {
        super(props);
        this.steps = [];
        this.stepIndex = 0;

        this.updateView = () => {
            var status = this.props.shipment.status;
            this.stepIndex = 0;
            //console.log("Updating view based on status...", status);
            var step4 = { title: <span>Delivered<br/>to you</span>, icon: 'icon-timeline-delivered' };
            if(status === "Cancelled" || status === "Ordered")
                this.stepIndex = 0;
            if(status === "PickedUp")
                this.stepIndex = 1;            
            if(status === "OFD" || status === "OFDOffSchedule")
                this.stepIndex = 2;            
            if(status === "PartialPOD" || status === "DriverNear")
                this.stepIndex = 3;            
            if(status === "Delivered" || status === "ManualPOD")
                this.stepIndex = 4;
            if(status === "Rejected") {
                step4 = { title: <span>Returned</span>, icon: 'icon-timeline-cross' };
                this.stepIndex = 4;
            }
    
            this.steps = [
                    { title: <span>Picked<br/>up</span>, icon: 'icon-timeline-pickup' },
                    { title: <span>On the<br/>way</span>, icon: 'icon-timeline-ofd' },
                    { title: <span>Close to<br/>home</span>, icon: 'icon-timeline-near' },
                    step4
                ];
        };
    }

    componentDidMount() {
        this.updateView();
    }

    render() {
        this.updateView();
        return (
            <div className="clearfix">
                <Stepper steps={this.steps} activeStep={this.stepIndex} />
            </div>
        );
    }
}